import React from "react";
import PropTypes from "prop-types";
import { Paper, Typography } from "@material-ui/core";

import BarraProceso from "../../general/BarraProceso";
import {
  pasoActual,
  pasosDelProceso,
  salioDeLaRuta,
  ultimoMovimiento,
} from "../model/proceso";

/**
 * "¿Como va mi proceso?": los estados por los que pasa la solicitud, con lo
 * ya recorrido en chulos. Usa BarraProceso, el mismo componente de los demas
 * modulos de Emma.
 *
 * Si la solicitud fue rechazada o cancelada no se pinta la barra: no son
 * parte del camino. En su lugar se dice en que quedo y por que.
 */
const ProcesoSolicitud = ({ solicitud }) => {
  const { ruta, estado_actual: estado, estados } = solicitud;

  if (!ruta || ruta.length === 0) return null;

  if (salioDeLaRuta(ruta, estado)) {
    const motivo = ultimoMovimiento(estados)?.mensaje;

    return (
      <Paper elevation={0} square style={{ padding: 16 }}>
        <Typography variant="body1">
          {`Esta solicitud quedo ${(estado?.nombre ?? "").toLowerCase()}.`}
        </Typography>
        {motivo && (
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
            {motivo}
          </Typography>
        )}
      </Paper>
    );
  }

  return (
    <BarraProceso
      steps={pasosDelProceso(ruta)}
      activeStep={pasoActual(ruta, estado)}
    />
  );
};

ProcesoSolicitud.propTypes = {
  solicitud: PropTypes.shape({
    ruta: PropTypes.array,
    estado_actual: PropTypes.object,
    estados: PropTypes.array,
  }).isRequired,
};

export default ProcesoSolicitud;
